module.exports = __webpack_public_path__ + "img/icon (8).0554c027.png";